<template>
    <v-toolbar-title class="d-flex">
        <v-icon :color="statusObject.color" class="mr-2">fiber_manual_record</v-icon>
        {{ statusObject.label }}
    </v-toolbar-title>
</template>
<script>
export default {
  props: {
    status: String, // Current status
    states: Array, // All states
    live: Object
  },
  data: function () {
    return {
      statusObject: []
    }
  },
  mounted: function () {
    // Check every state
    this.states.forEach((state) => {
      // If state equal to the current status
      if (this.status === state.id) {
        this.statusObject = state
      }
    })
  }
}
</script>
